import type {
  SecondaryFiltersOptionsAPIResponse,
  SecondaryFiltersOptionsPayload,
} from '@assembly-web/services';
import type { UseInfiniteQueryResult } from '@tanstack/react-query';
import { useInfiniteQuery } from '@tanstack/react-query';

import { getSecondaryFilterOptions } from '../queries/getSecondaryFilterOptionsQuery';

export function useGetSecondaryFilterOptionsQuery(
  payload: SecondaryFiltersOptionsPayload
): UseInfiniteQueryResult<SecondaryFiltersOptionsAPIResponse> {
  return useInfiniteQuery(getSecondaryFilterOptions(payload));
}
